import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { KnowledgeCenterInitialType } from '../utils/Types';
import { isAPISuccess } from '../utils/Util';
import {
  knowledgeCenterGetAllList,
  knowledgeCenterAddMedia,
  knowledgeCenterRemoveMedia,
  knowledgeCenterGetAllTypes,
} from '../services';
import { API_STATUS } from '../utils/Constant';

const blankMedia = {
  images: [],
  videos: [],
  pdfs: [],
  documents: [],
};

export const blankKnowledgeCenter = {
  media: blankMedia,
  tabs: [],
  status: '',
};

const initialState: KnowledgeCenterInitialType = blankKnowledgeCenter;

export const getKnowLedgeCenterMedia = createAsyncThunk(
  'knowledgeCenter/getKnowLedgeCenterMedia',
  async (params: any) => {
    const res = await knowledgeCenterGetAllList(params);
    return res.data;
  }
);

export const getTypes = createAsyncThunk(
  'knowledgeCenter/getTypes',
  async () => {
    const res = await knowledgeCenterGetAllTypes();
    return res.data;
  }
);

export const uploadMedia = createAsyncThunk<any, any>(
  'knowledgeCenter/UploadMedia',
  async (data: any) => {
    const res = await knowledgeCenterAddMedia(data);
    return res.data;
  }
);

export const removeMedia = createAsyncThunk<any, any>(
  'knowledgeCenter/removeMedia',
  async (param: any) => {
    const res = await knowledgeCenterRemoveMedia(param);
    return res.data;
  }
);

export const knowledgeCenterSlice = createSlice({
  name: 'knowledgeCenter',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getKnowLedgeCenterMedia.pending, (state) => {
        state.status = API_STATUS.LOADING;
      })
      .addCase(getKnowLedgeCenterMedia.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          state.media.pdfs = action.payload.result.pdf ?? [];
          state.media.videos = action.payload.result.videos ?? [];
          state.media.documents = action.payload.result.documents ?? [];
          state.media.images = action.payload.result.images ?? [];
          state.status = API_STATUS.SUCCEEDED;
        } else {
          state.media = blankMedia;
          state.status = API_STATUS.FAILED;
        }
      })
      .addCase(getTypes.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          state.tabs = action.payload.result ?? [];
          state.status = API_STATUS.SUCCEEDED;
        } else {
          state.tabs = [];
          state.status = API_STATUS.FAILED;
        }
      });
  },
});

export const knowledgeCenterSelector = (state: {
  knowledgeCenter: KnowledgeCenterInitialType;
}) => state.knowledgeCenter;

export default knowledgeCenterSlice.reducer;
